module.exports = __webpack_public_path__ + "static/img/2@2x.fb353bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/2@2x.png
// module id = DN7y
// module chunks = 0